// @ts-nocheck FIXME
import PropTypes from 'prop-types';
import React from 'react';

class CKEditor extends React.Component {
  constructor(props) {
    super(props);
    // Keep a copy of the editor to be used in various lifecycle functions
    this.editor = null;
    this.editorId = null;
    this.state = {
      focused: false,
    };

    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.setReadOnlyMode = this.setReadOnlyMode.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  componentDidMount() {
    // resolving scope issues for onload
    const editorId = this.editorId;
    const props = this.props;

    // create script object
    const script = document.createElement('script');
    script.src = '/legacy-libs/ckeditor/ckeditor.js?cb=3';

    // load file after component mounts to display the editor
    script.onload = function () {
      const component = this;

      // set editor to local scope
      this.editor = CKEDITOR;

      // create the editor
      CKEDITOR.replace(props.className + '-' + editorId, {
        customConfig: props.configs,
        removePlugins: 'contextmenu,liststyle,tabletools,elementspath',
      });

      // convience variable
      const editorInstance =
        this.editor.instances[this.props.className + '-' + this.editorId];
      const takeFocus = this.props.takeFocus;

      // Add the focus handler as soon as the editor is ready
      editorInstance.on('contentDom', function (instance) {
        const editor = instance.editor;
        const editable = editor.editable();

        component.setReadOnlyMode(component.props.disabled);
        document
          .querySelectorAll('.tc__cke-loading')
          .forEach((el) => (el.style.display = 'none'));

        editable.attachListener(editable, 'focus', component.handleFocus);
        editable.attachListener(editable, 'blur', component.handleBlur);
        if (takeFocus) {
          // I tried use ref, but so much is going on in this class that I can't make that work
          editor.focus();
        }

        // set a state variable for the parent component to properly calculate height
        if (props.setCkEditorMounted) {
          props.setCkEditorMounted(true);
        }
      });

      editorInstance.on('contentDomUnload', function (instance) {
        const editor = instance.editor;
        const editable = editor.editable();

        editable.removeListener(editable, 'focus', component.handleFocus);
        editable.removeListener(editable, 'blur', component.handleBlur);
      });
      if (props.onChange) {
        editorInstance.on('change', (e) => props.onChange(e));
      }
    }.bind(this);

    // append the script to the header
    document.head.appendChild(script);
  }

  componentDidUpdate() {
    this.setReadOnlyMode(this.props.disabled);
  }

  componentWillUnmount() {
    // convience variable
    const editorInstance =
      this.editor.instances[this.props.className + '-' + this.editorId];

    // blur the editor to prevent lingering focus event listener
    editorInstance.focusManager.blur(true);

    // remove instance of the editor
    editorInstance.destroy();
  }

  handleFocus() {
    // set state for blue border
    this.setState({ focused: true });

    // Call the parent's focus handler
    if (
      this.props.handleFocus &&
      typeof this.props.handleFocus === 'function'
    ) {
      this.props.handleFocus();
    }
  }

  handleBlur() {
    // set state for no border
    this.setState({ focused: false });

    // Call the parent's blur handler
    if (this.props.handleBlur && typeof this.props.handleBlur === 'function') {
      this.props.handleBlur();
    }
  }

  setReadOnlyMode(disabled) {
    if (
      this.editor &&
      this.editor.instances &&
      this.editor.instances[this.props.className + '-' + this.editorId]
    ) {
      if (
        ['ready', 'loaded'].indexOf(
          this.editor.instances[this.props.className + '-' + this.editorId]
            .status
        ) !== -1
      ) {
        this.editor.instances[
          this.props.className + '-' + this.editorId
        ].setReadOnly(disabled);
      }
    }
  }

  handleUpdate() {
    // get the output for this editor instance
    const editorOutput =
      this.editor.instances[
        this.props.className + '-' + this.editorId
      ].getData();

    // create data object
    const data = {
      entryData: {
        type: 'text',
        mode: 'update',
        data: {
          text: editorOutput,
        },
      },
    };

    if (this.props.id) {
      data.entryId = this.props.id;
    } else if (this.props.sectionId) {
      data.sectionId = this.props.sectionId;
    }

    // use store method to update the db
    this.props.update(data);
  }

  render() {
    this.editorId = this.props.id + '-' + this.props.increment;

    let buttonNode = null;
    if (this.props.update) {
      buttonNode = (
        <button
          onClick={this.handleUpdate}
          className={'ppt-element__btn tc__btn tc__btn--small tc__btn--blue'}
        >
          {this.props.id ? 'Update' : 'Add'}
        </button>
      );
    }
    const cols = this.props.cols || 80;
    const rows = this.props.rows || 10;
    const focusedClass = this.state.focused
      ? ' tc__cke-container--focused'
      : '';
    return (
      <div
        className={'tc__cke-container ' + this.props.className + focusedClass}
        data-testid={`ckeditor_${this.props.id}`}
      >
        <div className="tc__cke-loading"></div>
        <textarea
          className="tc__no-show"
          name={this.props.className + '-' + this.editorId}
          id={this.props.className + '-' + this.editorId}
          placeholder={this.props.placeholder}
          rows={rows}
          cols={cols}
          defaultValue={this.props.innerText}
        ></textarea>
        {buttonNode}
      </div>
    );
  }
}

CKEditor.propTypes = {
  disabled: PropTypes.bool.isRequired,
  setCkEditorMounted: PropTypes.func,
};

CKEditor.defaultProps = {
  disabled: false,
};

export default CKEditor;
